import { render } from "./AnchorLink.vue?vue&type=template&id=33ef99bf&ts=true"
import script from "./AnchorLink.vue?vue&type=script&lang=ts"
export * from "./AnchorLink.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__